// File is the combination of FilterAccounts, FilterPhysicinas, FilterProcedure, 
// FiltercreatedBy, FilterOrderStatus, FilterOrderType

import React, { useState } from 'react';
import DownArrowFilter from 'src/assets/images/DownArrowFilter.svg';
import { Dot } from 'src/styles/CommonStyles.styled';
import {
    FilterComponentWrapper,
    FilterComponentHeaderFooter,
    TextBold,
    LineSeparator,
    SearchBoxContainer,
    FilterItemDiv,
    FilterAccountNameDiv,
    FilterPhysicianNameDiv,
    FilterFavouriteIconDiv,
    OrderStatusGroup,
} from './Filters.styled';
import CommonRadioCheckboxFilter from './CommonRadioCheckboxFilter.jsx';
import CommonDateFilter from './CommonDateFilter.jsx';
import SearchBox from 'src/common/components/form/searchbox/index.jsx';
import FilterAccountLabel from './components/FilterAccountLabel';
import Star from 'src/assets/images/Star.svg';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import {
    anyAppliedOrCheckedFilter,
    anyAppliedFilterCheckDefault,
} from 'src/utils/util';
import {
    ORDER_STATUS_GROUPS,
    ORDER_LIST_ORDER_STATUS_ICONS,
} from 'src/constants/filterConstants.js';
import { DARK_NAVY_FONT_COLOR } from 'src/styles/fonts/MCFontConstants';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';

const CommonFilter = ({
    header,
    filters,
    onCheckBoxChange,
    isExpanded,
    updateExpandedViews,
    allFiltersWithStatus,
    reset = false,
    marginBottom,
    isPhysician = false,
    isAccount = false,
    isCreatedBy = false,
    isOrderStatus = false,
    isOrderType = false,
    isProcedure=false,
    isSpeciality=false,
    moreTemplateFilter,
    moreTemplateAccountFilter = false,
    moreTemplatePhysiciansFilter = false,
    moreTemplateProcedureFilter= false,
    moreTemplateCreatedByFilter=false,
    updateSearch,
    searchProduct,
    notGroupOrderStatus,
    isDefault,
    fromOrders,
    checkBoxName,
    isproductTemplate,
    view,
    NoCaseCoversion=false,
    forceDisabled=false,
    districtList= false,
    isDefaultButton = false,
    isFilterApplied,
    handleSetDefault = () => {},
    dateRange,
    onDateChange,
    isDateFilterApplied,
    isFim = false,
}) => {

    const { t } = useTranslation();
    const [isAppliedFilter, setAppliedFilter] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);

    useEffectWithErrorLogging(() => {
        if (typeof isDefault !== 'undefined' && isDefault) {
            setAppliedFilter(anyAppliedFilterCheckDefault(filters, isDefault));
        }else if (filters && allFiltersWithStatus ){
            setAppliedFilter(anyAppliedOrCheckedFilter(filters));
        }else if(isDateFilterApplied){
            setAppliedFilter(true);
        }
        else {
            setAppliedFilter(
                filters && filters.length > 0
                    ? filters.some(
                          isAccount
                              ? (item) => item.isChecked && item.name !== t('orders.orderStatuses.all') && item.name !== 'All'
                              : isPhysician
                              ? (item) => item.isChecked && item.name !== t('orders.orderStatuses.all') && item.name !== 'All'
                              : isCreatedBy
                              ? (item) => item.isChecked && item.name !== t('orders.orderStatuses.all') && item.name !== 'All'
                              : isOrderType
                              ? (item) => item.isChecked && (item.name || item.orderTypeName) !== t('orders.orderStatuses.all') && (item.name || item.orderTypeName) !== 'All' //? procedure
                              : isProcedure
                              ? (item) => item.isChecked && (item.description || item.name) !== t('orders.orderStatuses.all') && (item.description || item.name) !== 'All'
                              : districtList
                              ? ()=> false
                              //? (item) => item.isChecked && !item.isDefault &&(item.districtCode || item.districtName) !== t('orders.orderStatuses.all') && (item.districtCode || item.districtName) !== 'allDistricts'
                              : (item) => item.isChecked && !item.isDefault && (item.filterCode || item.filterName) !== t('orders.orderStatuses.all') && (item.filterCode || item.filterName) !== 'All'
                      )
                    : false
            );
        }

        // Check if the filter should be disabled
        let disabled = false;
        
        if (isAccount) {
            disabled = Array.isArray(filters) && filters?.filter((item) => item.name !== 'All').length === 0 && !moreTemplateAccountFilter;
        } else if (isPhysician) {
            disabled = Array.isArray(filters) && filters?.filter((item) => item.name !== 'All').length === 0 && !moreTemplatePhysiciansFilter;
        } else if(isSpeciality){
            disabled =  false;
        } else if (isCreatedBy) {
            disabled = Array.isArray(filters) && filters?.filter((item) => item.name !== 'All').length === 0 && !moreTemplateCreatedByFilter;
        } else if (isProcedure) {
            disabled = Array.isArray(filters) && filters?.filter((item) => (item.description || item.name) !== 'All').length === 0 && !moreTemplateProcedureFilter;
        } else if (isOrderType) {
            disabled = Array.isArray(filters) && filters?.filter((item) => (item.name || item.description) !== 'All').length === 0;
        } else if (isOrderStatus) {
            disabled = Array.isArray(filters) && filters?.filter((item) => (item.name || item.description) !== 'All').length === 0;
        } else if (districtList) {
            disabled = Array.isArray(filters) && filters?.filter((item) => (item.districtCode || item.districtName) !== 'All').length === 0;
        } else {
            disabled = false;
        }
        
        setIsDisabled(disabled || forceDisabled);
    }, [
        filters,
        isExpanded,
        allFiltersWithStatus,
        reset,
       forceDisabled,
        isAccount,
        isPhysician,
        isCreatedBy,
        isOrderStatus,
        isOrderType,
        isProcedure,
        moreTemplateAccountFilter,
        moreTemplatePhysiciansFilter,
        moreTemplateProcedureFilter,
        moreTemplateCreatedByFilter,
    ]);

    const filterOrdersTemplate = (filters, filterType) => {
        return filters?.length > 0 ? (
            <>
                {filters.map((filter, index) => {
                    let filterObject = filterType.filter(
                        (item) => item.description === filter.description
                    );
                    let isShowFilter = false;
                    let iconURL = null;
                    if (fromOrders) {
                        isShowFilter = true;
                    } else {
                        if (filterObject.length !== 0) {
                            isShowFilter = true;
                        }
                    }
                    if (isShowFilter) {
                        if (filterObject.length !== 0)
                            iconURL = filterObject[0].filterIconUrl;
                        return (
                            <React.Fragment key={index}>
                                <CommonRadioCheckboxFilter
                                    isCheckbox={true}
                                    key={filter.statusCode}
                                    filterItem={filter.description}
                                    filterItemId={filter.statusCode}
                                    iconUrl={iconURL}
                                    checkBoxName="orderStatusFilters"
                                    onCheckBoxChange={onCheckBoxChange}
                                    isChecked={filter.isChecked}
                                />
                            </React.Fragment>
                        );
                    }
                })}
            </>
        ) : null;
    };

    return (
        <FilterComponentWrapper
            className={isDisabled ? 'disabled' : ''}
            marginBottom={marginBottom}
        >
            <FilterComponentHeaderFooter
                onClick={() => {
                        updateExpandedViews({
                            view: isAccount
                                ? 'AccountView'
                                : isPhysician
                                ? 'PhysiciansView'
                                : isCreatedBy
                                ? 'CreatedBy'
                                : isOrderStatus
                                ? 'OrderStatusView'
                                : isOrderType
                                ? view
                                : view || 'ProcedureView',
                            value: !isExpanded,
                        });
                }}
            >
                <TextBold color={DARK_NAVY_FONT_COLOR}>{header}</TextBold>
                <div>
                    {!isDisabled && isExpanded ? (
                        <img
                            src={DownArrowFilter}
                            style={{ transform: 'rotate(180deg)' }}
                        />
                    ) : (
                        <div>
                            {isAppliedFilter ? <Dot /> : ''}
                            <img src={DownArrowFilter} />
                        </div>
                    )}
                </div>
            </FilterComponentHeaderFooter>
            {isOrderStatus &&
                (() => {
                    const { allObj } = ORDER_STATUS_GROUPS();
                    const { needsAction } = ORDER_STATUS_GROUPS();
                    const { information } = ORDER_STATUS_GROUPS();
                    const { iconList } = ORDER_LIST_ORDER_STATUS_ICONS();
                    if (
                        isExpanded &&
                        !notGroupOrderStatus &&
                        filters?.filter((item) => item.description !== 'All')
                            .length > 0
                    ) {
                        return (
                            <>
                                {' '}
                                <LineSeparator />
                                {filterOrdersTemplate(filters, allObj)}
                                <OrderStatusGroup>
                                    {t(
                                        'filter.filterOrderStatus.needActionLabel'
                                    )}
                                </OrderStatusGroup>
                                <LineSeparator />
                                {filterOrdersTemplate(filters, needsAction)}
                                <br />
                                <OrderStatusGroup>
                                    {t(
                                        'filter.filterOrderStatus.informationLabel'
                                    )}
                                </OrderStatusGroup>
                                <LineSeparator />
                                {filterOrdersTemplate(filters, information)}
                                <br />
                                {/* <br /> */}
                            </>
                        );
                    } else if (isExpanded && notGroupOrderStatus) {
                        return <>{filterOrdersTemplate(filters, iconList)}</>;
                    } else {
                        return <></>;
                    }
                })()}

            {isExpanded && !isOrderStatus && (
                <>
                    {(moreTemplateFilter || moreTemplateAccountFilter || moreTemplatePhysiciansFilter || moreTemplateProcedureFilter || moreTemplateCreatedByFilter) && (
                        <SearchBoxContainer>
                            <SearchBox
                                margin={'auto 0px auto 0px'}
                                updateSearch={updateSearch}
                                placeholder={
                                    isAccount
                                        ? t('accounts.accountSearchBox.account_Name_Number.placeholder')
                                        : isPhysician
                                        ? t('physicians.searchBox.physicianName.placeholder')
                                        : isCreatedBy
                                        ? t('ConsignmentAdd.common.bundleItems.createTemplate.enterCreatedByName')
                                        : t('ConsignmentAdd.common.bundleItems.createTemplate.placeholder')
                                }
                                width={'100%'}
                                height={'40px'}
                                borderRadius={'20px'}
                                paddingLeft={'2.2rem'}
                                isSearchIcon={true}
                                searchIconWidth={'min-content'}
                                fontSize={'14px'}
                                background={'none'}
                                enterkeyhint={'go'}
                                borderLeft={'none'}
                                labelColor="#040404"
                                fontWeight="400"
                                fontFamily="AvenirNextWorld, Regular"
                                padding={'0.5rem 2.2rem 0.6rem'}
                                autoComplete="off"
                                searchProduct={searchProduct}
                                right={'8%'}
                            />
                        </SearchBoxContainer>
                    )}
                    {filters.length !== 0 && <LineSeparator />}
                     {checkBoxName === 'SurgeryDateRangeView' &&
                        <CommonDateFilter
                            dateRange={dateRange}
                            onDateChange={onDateChange}
                            isFim={isFim}
                        />
                     }
                    {filters.map((filter) => {
                        if (isOrderType) {
                            return (
                                <CommonRadioCheckboxFilter
                                        isCheckbox={true}
                                        NoCaseCoversion={NoCaseCoversion}
                                        key={
                                            checkBoxName === 'OrderTypeView'
                                                ? filter.orderTypeCode
                                                : isproductTemplate
                                                ? filter.typeId
                                                : filter.statusCode
                                        }
                                        filterItem={
                                            checkBoxName === 'OrderTypeView'
                                                ? filter.orderTypeName
                                                : isproductTemplate
                                                ? filter.name
                                                : filter.description
                                        }
                                        filterItemId={
                                            checkBoxName === 'OrderTypeView'
                                                ? filter.orderTypeCode
                                                : isproductTemplate
                                                ? filter.typeId
                                                : filter.statusCode
                                        }
                                        iconUrl={false}
                                        checkBoxName={checkBoxName}
                                        onCheckBoxChange={onCheckBoxChange}
                                        isChecked={filter.isChecked}
                                        lastElement={
                                            checkBoxName === 'OrderTypeView'
                                                ? filters[filters.length - 1]
                                                      .orderTypeName
                                                : filters[filters.length - 1]
                                                      .name
                                        }
                                        orderType={true}
                                    />
                            );
                        } else if (isAccount) {
                            return (
                                <CommonRadioCheckboxFilter
                                    isCheckbox={true}
                                    key={filter.accountId}
                                    filterItem={filter.name}
                                    filterItemId={filter.accountId}
                                    onCheckBoxChange={onCheckBoxChange}
                                    checkBoxName="accountFilters"
                                    isChecked={filter.isChecked}
                                    isFavourite={filter.isFavourite || filter.isFavorite}
                                    singleLineDisplay={true}
                                    accountId={filter.accountId}
                                    lastElement={filters[filters.length - 1].name}
                                >
                                    {filter.accountId ? (
                                        <FilterAccountLabel
                                            name={filter.name}
                                            accountId={filter.accountId === 1 ? '' : filter.accountId }
                                            showFavourite={true}
                                            isFavourite={filter?.isFavourite ? filter.isFavourite : filter?.isFavorite ? filter.isFavorite : false}
                                        />
                                    ) : (
                                        <FilterItemDiv>
                                            <FilterAccountNameDiv maxWidth={'100%'}>
                                                {filter.name === 'All' ? t('common.allLabel') : filter.name}
                                            </FilterAccountNameDiv>
                                        </FilterItemDiv>
                                    )}
                                </CommonRadioCheckboxFilter>
                            );
                        } else if (isPhysician) {
                            return (
                                <CommonRadioCheckboxFilter
                                    isCheckbox={true}
                                    key={`physicianFilters-${filter.physicianId}`}
                                    filterItem={filter.name}
                                    filterItemId={filter.physicianId}
                                    checkBoxName="physiciansFilters"
                                    onCheckBoxChange={onCheckBoxChange}
                                    isChecked={filter.isChecked}
                                    lastElement={filters[filters.length - 1].name}
                                >
                                    <FilterItemDiv>
                                        <FilterPhysicianNameDiv>
                                            {filter.name === 'All'
                                                ? t('common.allLabel')
                                                : filter.name}{' '}
                                            &nbsp;
                                        </FilterPhysicianNameDiv>
                                        <FilterFavouriteIconDiv>
                                            {filter.isFavourite && (
                                                <img
                                                    src={Star}
                                                    alt="Favourite"
                                                    style={{ width: '16px', height: '16px' }}
                                                />
                                            )}
                                        </FilterFavouriteIconDiv>
                                    </FilterItemDiv>
                                </CommonRadioCheckboxFilter>
                            );
                        } else if (isCreatedBy) {
                            return (
                                <CommonRadioCheckboxFilter
                                    isCheckbox={true}
                                    key={`createdByFilters-${filter.createdId}`}
                                    filterItem={filter.name}
                                    onCheckBoxChange={onCheckBoxChange}
                                    filterItemId={filter.createdId}
                                    checkBoxName="createdByFilters"
                                    isChecked={filter.isChecked}
                                    lastElement={filters[filters.length - 1].name}
                                />
                            );
                        } else if (isProcedure) {
                            // Procedure
                            return (
                                <CommonRadioCheckboxFilter
                                    isCheckbox={true}
                                    key={`procedureFilters-${filter.procedureId}`}
                                    filterItem={filter.description}
                                    filterItemId={filter.procedureId}
                                    checkBoxName="procedureFilters"
                                    onCheckBoxChange={onCheckBoxChange}
                                    isChecked={filter.isChecked}
                                    lastElement={filters[filters.length - 1].name}
                                />
                            );
                        }else if (districtList) {
                            // districtList
                            return (
                                <CommonRadioCheckboxFilter
                                    isCheckbox={true}
                                    key={`districtFilters-${filter.districtCode}`}
                                    filterItem={filter.districtName}
                                    filterItemId={filter.districtCode}
                                    checkBoxName={checkBoxName}
                                    onCheckBoxChange={onCheckBoxChange}
                                    isChecked={filter.isChecked}
                                    lastElement={filters[filters.length - 1].name}
                                     isDefault={filter?.isDefault}
                                />
                            );
                        }else if(checkBoxName === 'SurgeryTypeView' || checkBoxName === 'AllocatedView'){
                            // SurgeryType as radio buttons
                            return (
                                <CommonRadioCheckboxFilter
                                    isRadio={true}
                                    key={`${checkBoxName}-${filter.filterCode}`}
                                    radioName={checkBoxName}
                                    filterItemRadio={{ id: filter.filterCode, name: filter.filterName }}
                                    filterItemId={filter.filterCode}
                                    setSelectedCalendarView={(selected, name) => {
                                        onCheckBoxChange({ target: { value: selected.id } }, name);
                                    }}
                                    isChecked={filter.isChecked}
                                    lastElement={filters[filters.length - 1].filterName}
                                    isDefault={filter?.isDefault}
                                />
                            );
                        } else{
                            return (
                            <CommonRadioCheckboxFilter
                                    isCheckbox={true}
                                    key={`checkBoxName-${filter.filterCode}`}
                                    filterItem={filter.filterName}
                                    filterItemId={filter.filterCode}
                                    checkBoxName={checkBoxName}
                                    onCheckBoxChange={onCheckBoxChange}
                                    isChecked={filter.isChecked}
                                    lastElement={filters[filters.length - 1].name}
                                    isDefault={filter?.isDefault}
                                />
                            );
                        }
                    })}
                     {isDefaultButton && (
                            <FilterComponentHeaderFooter>
                            <Button
                                id={'set-default-calendar-view-button'}
                                show={true}
                                width={'100%'}
                                height={'38px'}
                                clicked={()=>{handleSetDefault(checkBoxName)}}
                                disabled={!isFilterApplied}
                                variant={isFilterApplied ? ButtonStyles?.primary : ButtonStyles?.disabled}
                            >
                            <TextBold color={'#FFFF'}>
                                {t('filter.setDefaultButton')}
                            </TextBold>
                           </Button>
                    </FilterComponentHeaderFooter>)}
                </>
            )}
        </FilterComponentWrapper>
    );
};

export default CommonFilter;
